import styled from 'styled-components';
import React from 'react';
import { PROFILE } from './lang';
import { useAuth } from '../../contexts';

export type DelegatePanelProps = {
  delegating?: boolean;
};

export const DelegatePanel: React.FunctionComponent<DelegatePanelProps> = (
  props: DelegatePanelProps,
) => {
  const { user } = useAuth();

  return (
    <UserPanelContainer>
      <UserPanelItem className="whitespace-nowrap">
        <div className="font-semibold">{PROFILE.DELEGATING}</div>
        <div>{user?.sub ?? 'N/A'}</div>
      </UserPanelItem>

      <UserPanelItem className="whitespace-nowrap">
        <div className="font-semibold">{PROFILE.ROLE}</div>
        <div>{PROFILE.SUPERVISOR}</div>
      </UserPanelItem>
    </UserPanelContainer>
  );
};

const UserPanelContainer = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #767676;
`;

const UserPanelItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    margin-right: 8px;
  }
`;
